<template>
	<v-row
		:align="align"
		:align-content="alignContent"
		:class="noPadding ? '' : `pl-4 pr-4`"
	>
		<slot></slot>
	</v-row>
</template>

<script>
export default {
	props: {
		align: String,
		alignContent: String,
		noPadding: Boolean,
	},
}
</script>
